import styled from "styled-components";
import Link from "../../components/Link";

const MagazineBlockLink = styled(Link)``;

MagazineBlockLink.defaultProps = {};

export { MagazineBlockLink };
